import axios from "axios";

export default function getBusinessHours() {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/business-hours")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
